import clsx from "clsx";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { BgImage, Logo, Panel } from "../../components";
import { rootOutliner } from "../../data/outliner";
import "./style.scss";

export interface HomeViewProps {
    isMobile: boolean;
}

export const HomeView = () => {
    const navigate = useNavigate();

    return (
        <div className={clsx("home-view", isMobile && "mobile")}>
            <Logo />

            <div className="home-list">
                {rootOutliner.map((item) => {
                    return (
                        <Panel
                            icon="blender"
                            title={item.name}
                            key={item.id}
                            className="item hvr-fade hvr-grow-shadow"
                            onClick={(e) => {
                                navigate(`/Projects/${item.name}`);
                            }}
                        >
                            <BgImage
                                src={`${item.imageResouce?.path}/${item.imageResouce?.primaryImg}_thumb.png`}
                                minHeight={100}
                                maxHeight={300}
                                height="100%"
                            />
                        </Panel>
                    );
                })}
            </div>
        </div>
    );
};
